<template>
  <div id="create-tenant">
    <label @click="$router.push({ name: 'platform-admin.tenants.index' })" class="back">
      <figure>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </figure>
      <p>Voltar</p>
    </label>
    <section class="photo">
      <h1>Logo do tenant</h1>
      <div class="data" :class="{ 'nophoto': !logoPreview }">
        <div :style="{ backgroundImage: logoPreview ? 'url(' + logoPreview + ')' : '' }">
          <label class="tooltip" for="tenant-logo">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </label>
        </div>
        <input autocomplete='off' type="file" accept="image/*" name="tenant-logo" id="tenant-logo" @change="handleLogoChange($event)">
        <p>A logo é exibida no menu do tenant para os usuários daquela conta.</p>
      </div>
    </section>
    <section class="double">
      <section>
        <h1><strong>Nome</strong> (obrigatório)</h1>
        <input type="text" placeholder="Ex: Prefeitura de Canindé" v-model="payload.name">
      </section>
      <section>
        <h1><strong>Sigla</strong></h1>
        <input type="text" placeholder="Ex: P.M.C" v-model="payload.acronym">
      </section>
    </section>
    <section>
      <h1><strong>Setor</strong> (obrigatório)</h1>
      <MySelect :name="'sector'" :for="'sector'" :currentValue="payload.sector ? tenantSectorLabels[payload.sector] : null">
        <li v-for="sector in Object.values(TenantSectorEnum)" :key="sector" @mousedown="payload.sector = sector">{{ tenantSectorLabels[sector] }}</li>
      </MySelect>
    </section>
    <section class="spacing">
      <h1><strong>Módulos</strong></h1>
      <h2>Controle quais funcionalidades pagas este tenant tem acesso.</h2>
      <div class="modules">
        <label class="module-toggle" v-for="module in Object.values(TenantModuleEnum)" :key="module">
          <input type="checkbox" :checked="payload.modules.includes(module)" @change="toggleModule(module, ($event.target as HTMLInputElement).checked)">
          <span></span>
          <p>{{ tenantModuleLabels[module] }}</p>
        </label>
      </div>
    </section>
    <section class="spacing">
      <h1><strong>Perfis de acesso</strong> (obrigatório ao menos 1)</h1>
      <h2>Perfis padrão que serão criados junto com o tenant. Desmarque os que não forem necessários.</h2>
      <div class="modules">
        <label class="module-toggle" v-for="template in TENANT_ROLE_TEMPLATES" :key="template.name">
          <input type="checkbox" :checked="payload.roles.includes(template.name)" @change="toggleRole(template.name, ($event.target as HTMLInputElement).checked)">
          <span></span>
          <p>{{ template.name }}</p>
        </label>
      </div>
    </section>
    <section class="spacing">
      <h1><strong>Assuntos de documento</strong></h1>
      <h2>Assuntos padrão que serão criados junto com o tenant. Desmarque os que não forem necessários ou adicione novos.</h2>
      <div class="subjects-grid">
        <label class="subject-chip" v-for="subject in allSubjectOptions" :key="subject">
          <input type="checkbox" :checked="payload.documentSubjects.includes(subject)" @change="toggleSubject(subject, ($event.target as HTMLInputElement).checked)">
          <span></span>
          <p>{{ subject }}</p>
        </label>
      </div>
      <div class="add-subject">
        <input type="text" placeholder="Adicionar assunto personalizado" v-model="customSubjectInput" @keydown.enter.prevent="addCustomSubject">
        <input type="button" value="Adicionar" :disabled="!customSubjectInput.trim()" @click="addCustomSubject">
      </div>
    </section>
    <section class="spacing users-section">
      <h1><strong>Usuários</strong> (obrigatório ao menos 1)</h1>
      <h2>Esses usuários serão criados junto com o tenant e poderão acessá-lo imediatamente.</h2>
      <div class="user-form" v-for="(newUser, index) in payload.users" :key="index">
        <button v-if="payload.users.length > 1" class="remove" @click="removeUserRow(index)">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6 6L18 18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <section class="double">
          <section>
            <input type="text" placeholder="Nome" v-model="newUser.name">
          </section>
          <section>
            <input type="text" placeholder="Sobrenome" v-model="newUser.last_name">
          </section>
        </section>
        <section class="double">
          <section>
            <input type="text" placeholder="E-mail" v-model="newUser.email">
          </section>
          <section>
            <input type="text" placeholder="Senha (mín. 6 caracteres)" v-model="newUser.password">
          </section>
        </section>
        <section>
          <MySelect :name="`user-${index}-role`" :for="`user-${index}-role`" :currentValue="newUser.role ?? null">
            <li v-for="roleName in payload.roles" :key="roleName" @mousedown="newUser.role = roleName">{{ roleName }}</li>
          </MySelect>
        </section>
      </div>
      <button class="add-user-row" @click="addUserRow">+ adicionar outro usuário</button>
    </section>
    <nav>
      <input v-if="!isCreatingTenant" type="button" value="Criar tenant" :disabled="!canSubmit" @click="createTenant">
      <SpinnerLoaderButton v-else :height="60" :maxWidth="464"/>
      <input type="button" value="Cancelar" @click="$router.push({ name: 'platform-admin.tenants.index' })">
    </nav>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import MySelect from '@/components/select/MySelect.vue'
import { useAxios } from '@/api/axios'
import { AxiosResponse } from 'axios'
import { TenantModel } from '@/models/TenantModel'
import { TenantSectorEnum, tenantSectorLabels } from '@/enums/Tenants/TenantSectorEnum'
import { TenantModuleEnum, tenantModuleLabels } from '@/enums/Tenants/TenantModuleEnum'
import { TENANT_ROLE_TEMPLATES, DEFAULT_DOCUMENT_SUBJECTS } from '@/global/config/tenantProvisioningDefaults'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import { toast } from 'vue3-toastify'
import router from '@/router'

interface NewTenantUser {
  name?: string
  last_name?: string
  email?: string
  password?: string
  role?: string
}

const axios = useAxios()
const isCreatingTenant = ref(false)
const logoPreview = ref<string>('')
const customSubjectInput = ref('')
const customSubjects = ref<string[]>([])

const payload = ref<{
  name?: string
  acronym?: string
  sector?: TenantSectorEnum
  logo?: File
  modules: TenantModuleEnum[]
  roles: string[]
  documentSubjects: string[]
  users: NewTenantUser[]
}>({
  modules: [],
  roles: TENANT_ROLE_TEMPLATES.filter((template) => !template.chamberOnly).map((template) => template.name),
  documentSubjects: [...DEFAULT_DOCUMENT_SUBJECTS],
  users: [{}]
})

const allSubjectOptions = computed(() => [...DEFAULT_DOCUMENT_SUBJECTS, ...customSubjects.value])

const canSubmit = computed(() => {
  if (!payload.value.name || !payload.value.sector || !payload.value.roles.length) return false
  if (!payload.value.users.length) return false
  return payload.value.users.every((newUser) => {
    return !!(newUser.name && newUser.last_name && newUser.email && newUser.password && newUser.password.length >= 6 && newUser.role && payload.value.roles.includes(newUser.role))
  })
})

watch(() => payload.value.sector, (sector) => {
  const chamberOnlyNames = TENANT_ROLE_TEMPLATES.filter((template) => template.chamberOnly).map((template) => template.name)

  if (sector === TenantSectorEnum.CHAMBER) {
    chamberOnlyNames.forEach((name) => {
      if (!payload.value.roles.includes(name)) payload.value.roles.push(name)
    })
  } else {
    payload.value.roles = payload.value.roles.filter((roleName) => !chamberOnlyNames.includes(roleName))
  }
})

function handleLogoChange (event: Event) {
  const input = event.target as HTMLInputElement
  const file: File | null = input.files && input.files[0]
  if (file) {
    payload.value.logo = file
    logoPreview.value = URL.createObjectURL(file)
  }
}

function toggleModule (module: TenantModuleEnum, checked: boolean) {
  const modules = new Set(payload.value.modules)
  checked ? modules.add(module) : modules.delete(module)
  payload.value.modules = Array.from(modules)
}

function toggleRole (roleName: string, checked: boolean) {
  const roles = new Set(payload.value.roles)
  checked ? roles.add(roleName) : roles.delete(roleName)
  payload.value.roles = Array.from(roles)
}

function toggleSubject (subject: string, checked: boolean) {
  const subjects = new Set(payload.value.documentSubjects)
  checked ? subjects.add(subject) : subjects.delete(subject)
  payload.value.documentSubjects = Array.from(subjects)
}

function addCustomSubject () {
  const value = customSubjectInput.value.trim()
  if (!value || allSubjectOptions.value.includes(value)) return

  customSubjects.value.push(value)
  payload.value.documentSubjects.push(value)
  customSubjectInput.value = ''
}

function addUserRow () {
  payload.value.users.push({})
}

function removeUserRow (index: number) {
  payload.value.users.splice(index, 1)
}

function createTenant (): void {
  isCreatingTenant.value = true

  const formData = new FormData()
  formData.append('name', payload.value.name!)
  if (payload.value.acronym) {
    formData.append('acronym', payload.value.acronym)
  }
  formData.append('sector', payload.value.sector!)
  if (payload.value.logo) {
    formData.append('logo', payload.value.logo)
  }
  payload.value.modules.forEach((module, index) => {
    formData.append(`modules[${index}]`, module)
  })
  payload.value.roles.forEach((roleName, index) => {
    formData.append(`roles[${index}]`, roleName)
  })
  payload.value.documentSubjects.forEach((subject, index) => {
    formData.append(`document_subjects[${index}]`, subject)
  })
  payload.value.users.forEach((newUser, index) => {
    formData.append(`users[${index}][name]`, newUser.name!)
    formData.append(`users[${index}][last_name]`, newUser.last_name!)
    formData.append(`users[${index}][email]`, newUser.email!)
    formData.append(`users[${index}][password]`, newUser.password!)
    formData.append(`users[${index}][role]`, newUser.role!)
  })

  axios.post('/api/platform-admin/tenants', formData)
    .then((res: AxiosResponse<TenantModel>) => {
      toast.success('Tenant criado com sucesso')
      router.push({ name: 'platform-admin.tenants.edit', params: { id: res.data.id } })
    })
    .finally(() => isCreatingTenant.value = false)
}
</script>

<style lang="scss">
  #create-tenant{
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: start;
    row-gap: 28px;
    section{
      width: 100%;
      display: flex;
      flex-direction: column;
      position: relative;
      &.double{
        display: flex;
        flex-direction: row;
        column-gap: 20px;
      }
      h1{
        color: #090909;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 0 0 13px 0;
        text-align: start;
        strong{
          color: #090909;
          font-family: 'Inter', sans-serif;
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }
      }
      h2{
        color: #6F6F6F;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-align: start;
        margin: -13px 0 13px 0;
      }
      input[type="text"]{
        width: 100%;
        height: 55px;
        border-radius: 14px;
        border: 1px solid #D3D3D3;
        color: $fluxoo-primary-color;
        font-family: 'Inter', sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding: 15px 20px;
        box-sizing: border-box;
        transition: border-color .2s, color .2s, background .2s;
        &:focus{
          outline: none;
        }
        &::placeholder{
          color: #090909;
          font-family: 'Inter', sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
      &.photo{
        row-gap: 13px;
        margin: 0 0 20px 0;
        animation: enterContent ease .4s;
        h1{
          font-size: 20px;
          font-weight: 700;
          margin: 0;
        }
        input{
          display: none;
        }
        .data{
          display: flex;
          align-items: center;
          column-gap: 24px;
          &.nophoto{
            div{
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              &::before{
                content: 'logo do tenant';
                color: #6F6F6F;
                text-align: center;
                font-family: 'Inter', sans-serif;
                font-size: 13px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                position: absolute;
                top: 65px;
              }
            }
          }
          > div{
            width: 170px;
            min-width: 170px;
            height: 170px;
            min-height: 170px;
            display: flex;
            justify-content: center;
            border-radius: 50%;
            background: #F1F1F1;
            background-position: center 0;
            background-size: cover;
            background-repeat: no-repeat;
            label{
              width: 45px;
              min-width: 45px;
              height: 45px;
              min-height: 45px;
              display: flex;
              border-radius: 50%;
              background: #FFF;
              align-items: center;
              justify-content: center;
              margin: 100px 0 0 0;
              transition: background .2s;
              cursor: pointer;
              filter: drop-shadow(0px 0px 25px rgba(0, 0, 0, 0.12));
              &:hover{
                background: $fluxoo-primary-color;
                svg{
                  stroke: #FFF;
                }
              }
              svg{
                width: 24px;
                min-width: 24px;
                height: 24px;
                stroke: #090909;
                margin: auto auto;
                transition: stroke .2s;
              }
            }
          }
          p{
            color: #6F6F6F;
            font-family: 'Inter', sans-serif;
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            max-width: 300px;
            text-align: start;
            margin: 0;
          }
        }
      }
      .modules{
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        .module-toggle{
          width: fit-content;
          display: flex;
          align-items: center;
          column-gap: 12px;
          cursor: pointer;
          input{
            display: none;
            &:checked{
              & ~ span{
                background: $fluxoo-primary-color-hover;
                &::before{
                  background: $fluxoo-primary-color;
                  left: calc(100% - 25px);
                }
              }
            }
          }
          span{
            width: 43px;
            min-width: 43px;
            height: 11px;
            background: #949494;
            border-radius: 12px;
            position: relative;
            transition: background .2s;
            &::before{
              content: '';
              width: 25px;
              height: 25px;
              background: #D5D5D5;
              border-radius: 50%;
              position: absolute;
              top: -7px;
              left: 0;
              transition: background .2s, left .2s;
            }
          }
          p{
            color: #090909;
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            margin: 0;
          }
        }
      }
      .subjects-grid{
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin: 0 0 20px 0;
        .subject-chip{
          width: fit-content;
          display: flex;
          align-items: center;
          column-gap: 8px;
          padding: 10px 16px;
          border-radius: 20px;
          border: 1px solid #D3D3D3;
          cursor: pointer;
          transition: border-color .2s, background .2s;
          input{
            display: none;
            &:checked ~ span{
              background: $fluxoo-primary-color;
              border-color: $fluxoo-primary-color;
              &::before{
                content: '';
                width: 4px;
                height: 8px;
                border-right: 2px solid #FFF;
                border-bottom: 2px solid #FFF;
                position: absolute;
                top: 1px;
                left: 4px;
                transform: rotate(45deg);
              }
            }
          }
          span{
            width: 16px;
            min-width: 16px;
            height: 16px;
            min-height: 16px;
            border-radius: 4px;
            border: 1px solid #6F6F6F;
            position: relative;
            transition: border-color .2s, background .2s;
          }
          p{
            color: #090909;
            font-family: 'Inter', sans-serif;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            margin: 0;
          }
        }
      }
      .add-subject{
        display: flex;
        align-items: center;
        column-gap: 12px;
        input[type="text"]{
          height: 50px;
        }
        input[type="button"]{
          width: fit-content;
          height: 50px;
          padding: 0 24px;
          border: none;
          border-radius: 14px;
          background: $fluxoo-primary-color;
          color: #FFF;
          font-family: 'Inter', sans-serif;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          white-space: nowrap;
          cursor: pointer;
          transition: background .2s;
          &:hover{
            background: $fluxoo-primary-color-hover;
          }
          &:disabled{
            background: #F1F1F1 !important;
            color: #6F6F6F !important;
            cursor: not-allowed !important;
          }
        }
      }
      &.users-section{
        > h2{
          margin: -13px 0 20px 0;
        }
        .user-form{
          width: 100%;
          display: flex;
          flex-direction: column;
          row-gap: 16px;
          padding: 24px;
          border-radius: 24px;
          background: #F5F8F7;
          box-sizing: border-box;
          position: relative;
          margin: 0 0 16px 0;
          .remove{
            position: absolute;
            top: 16px;
            right: 16px;
            width: 28px;
            min-width: 28px;
            height: 28px;
            min-height: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            transition: background .2s;
            cursor: pointer;
            svg{
              stroke: #090909;
              transition: stroke .2s;
            }
            &:hover{
              background: #FFF;
              svg{
                stroke: #EB1320;
              }
            }
          }
        }
        .add-user-row{
          width: fit-content;
          color: $fluxoo-primary-color;
          font-family: 'Inter', sans-serif;
          font-size: 15px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          cursor: pointer;
          transition: color .2s;
          &:hover{
            color: $fluxoo-primary-color-hover;
          }
        }
      }
    }
    nav{
      width: 100%;
      max-width: 1200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px 32px;
      border-radius: 16px;
      background: #FFF;
      box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.12);
      box-sizing: border-box;
      position: sticky;
      bottom: 5px;
      column-gap: 20px;
      margin: auto 0 0 0;
      input{
        border: none;
        cursor: pointer;
        &:first-child{
          width: 100%;
          max-width: 464px;
          height: 60px;
          border-radius: 30px;
          background: $fluxoo-primary-color;
          color: #FFF;
          text-align: center;
          font-family: 'Inter', sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          transition: background .2s;
          &:hover{
            background: $fluxoo-primary-color-hover;
          }
          &:disabled{
            background: #F1F1F1 !important;
            color: #6F6F6F !important;
            cursor: not-allowed !important;
          }
        }
        &:last-child{
          color: #737373;
          font-family: 'Inter', sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          background: unset;
          transition: color .2s;
          &:hover{
            color: $fluxoo-primary-color;
          }
        }
      }
    }
  }

  @media(max-width: 700px){
    #create-tenant{
      section{
        &.double{
          flex-direction: column !important;
          row-gap: 28px;
        }
      }
    }
  }

  @media(max-width: 425px){
    #create-tenant{
      padding: 0 0 120px 0;
      nav{
        animation: enterToBottom ease 0.9s;
        width: 100vw;
        position: fixed;
        left: 0;
        bottom: 0;
        border-radius: 20px 20px 0px 0px;
        background: #FFF;
        box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.12);
        padding: 15px;
        box-sizing: border-box;
        z-index: 4;
      }
    }
  }
</style>
